// extracted by mini-css-extract-plugin
export default {"observationLabel":"observationLabel__ViUP7","cardContent":"cardContent__3ClrA","cardBody":"cardBody"};